import React from 'react'
import styled, { css } from 'styled-components'
import ButtonShell from 'components/elements/Buttons/ButtonShell'

export const ButtonPrimaryCSS = css`
  background-color: ${({ theme }) => theme.color.primary};
  display: inline-block;
  border: 2px solid ${({ theme }) => theme.color.primary};

  &:hover {
    background-color: ${({ theme }) => theme.color.light};

    & > a,
    & > button {
      color: ${({ theme }) => theme.color.dark} !important;
      text-decoration: underline;
    }
  }

  & > a,
  & > button {
    color: ${(props) => props.theme.color.light} !important;
    font-weight: ${({ theme }) => theme.font.weight.semiBold};
    display: flex;
    align-items: center;
    justify-content: center;

    @media (min-width: 992px) {
      font-size: ${({ theme }) => theme.font.size.big};
      height: 46px;
      padding: 0 30px;
    }

    @media (max-width: 991px) {
      font-size: ${({ theme }) => theme.font.size.small};
      height: 36px;
      padding: 0 20px;
    }
  }

  @media (min-width: 992px) {
    min-width: 220px;
  }
`

const StyledButton = styled.span`
  ${ButtonPrimaryCSS};
`

interface ButtonPrimaryProps {
  isAnchor?: boolean
  isCustom?: boolean
  to: string
  className?: string
  target?: string
}

const ButtonPrimary: React.FC<ButtonPrimaryProps> = ({
  isAnchor = false,
  isCustom = false,
  to,
  children,
  className = '',
  target = '',
}) => (
  <StyledButton className={className}>
    {isCustom ? (
      children
    ) : (
      <ButtonShell to={to} isAnchor={isAnchor} target={target}>
        {children}
      </ButtonShell>
    )}
  </StyledButton>
)

export default ButtonPrimary
